"use client";

import { memo } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { selectFilterOptions } from "@/feature/flight/search/state/selectors";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  setFilters,
} from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import AccordionSection from "./accordion-section";

const Aircraft = memo(() => {
  const dispatch = useAppDispatch();
  const { selectOption, defaultOption } = useAppSelector(
    selectFilterOptions,
  );
  const isResponseEnd = useAppSelector((state) => state.flightSearchStatus.isResponseEnd);

  const selected = selectOption?.aircraft ?? [];
  const aircraft = defaultOption?.aircraft ?? [];

  const handleChange = (value?: string) => {
    if (!value) return;

    const isSelected = selected.includes(value);
    const updated = isSelected
      ? selected.filter((v) => v !== value)
      : [...selected, value];

    dispatch(setFilters({ aircraft: updated }));
  };

  return (
    <AccordionSection value="aircraft" label="Aircraft">
      {aircraft.map((item) => {
        const checked = selected.includes(item);
        return (
          <div key={item} className="flex items-center space-x-2">
            <Checkbox
              disabled={!isResponseEnd}
              id={item}
              checked={checked}
              onCheckedChange={() => handleChange(item)}
            />
            <Label htmlFor={item} className="font-normal cursor-pointer w-full">
              {item}
            </Label>
          </div>
        );
      })}
    </AccordionSection>
  );
});

Aircraft.displayName = "Aircraft";
export default Aircraft;


